import React, { ReactElement } from 'react';
import { Toaster, type ToasterProps } from 'sonner';
import { ShadcnToaster } from 'shadcn-ui';
import { PopupContext } from 'ui-builder';
import useFeatureToggleService from 'feature-toggle';

import './Toast.scss';

const sharedToasterProps: ToasterProps = {
  position: 'bottom-right',
  theme: 'dark',
  duration: 5000,
  richColors: true,
};

function ToastRenderer() {
  const { isShadcnUiEnabled } = useFeatureToggleService();

  if (isShadcnUiEnabled()) {
    return <ShadcnToaster {...sharedToasterProps} />;
  } else {
    return <Toaster {...sharedToasterProps} />;
  }
}

export function ToastContext(props: { children: ReactElement | ReactElement[] }) {
  return (
    <PopupContext>
      {props.children}
      <ToastRenderer />
    </PopupContext>
  );
}
